import { Button, TextArea } from '@calizahq/react-components-v2'
import { Form } from 'formik'
import React from 'react'

import { InputFile, InputSelect } from '@/components'
import { useMobile } from '@/hooks'
import { HomeIssueType } from '@/types/HomeIssue'

type Props = {
  error?: string | undefined
  homeInventoryItemOptions?: Array<{
    label: string
    value?: number
  }>
  homeIssueType?: HomeIssueType
  homeLocationOptions?: Array<{
    label: string
    value?: number
  }>
  isCapturing?: boolean
  isMutationLoading: boolean
  toggle: () => void
}

export const HomeIssueForm = ({
  error,
  homeIssueType,
  homeInventoryItemOptions,
  homeLocationOptions,
  isCapturing = false,
  isMutationLoading,
  toggle,
}: Props) => {
  const { isTablet } = useMobile()

  const homeIssueOptions = Object.keys(HomeIssueType).map((key) => {
    return { label: HomeIssueType[key], value: HomeIssueType[key] }
  })

  const showHomeInventoryItem =
    homeIssueType === HomeIssueType.DAMAGE || homeIssueType === HomeIssueType.REPLACEMENT_NEEDED

  return (
    <Form className="flex w-full flex-col flex-wrap px-6 md:max-w-120">
      <div className="flex w-full flex-col md:mb-4 md:grid md:grid-cols-1 md:gap-4">
        <InputSelect
          className=" mb-4 w-full md:mb-0 md:mr-4"
          id="type"
          label="Type"
          name="type"
          options={homeIssueOptions}
        />
      </div>
      <div className="flex w-full flex-col md:mb-4 md:grid md:grid-cols-1 md:gap-4">
        <InputSelect
          className=" mb-4 w-full md:mb-0 md:mr-4"
          id="homeLocationId"
          label="Location"
          name="homeLocationId"
          options={homeLocationOptions}
        />
      </div>

      {showHomeInventoryItem && (
        <div className="flex w-full flex-col md:mb-4 md:grid md:grid-cols-1 md:gap-4">
          <InputSelect
            className=" mb-4 w-full md:mb-0 md:mr-4"
            id="homeInventoryItemId"
            label="Inventory Item"
            name="homeInventoryItemId"
            options={homeInventoryItemOptions}
          />
        </div>
      )}

      <TextArea className="mb-4 w-full" label="Add notes" name="notes" />

      <InputFile
        accept={{
          'image/jpeg': [],
          'image/png': [],
        }}
        className="mb-4"
        gridClassName="grid-cols-3 md:grid-cols-5"
        id="attachments"
        isPreview={true}
        maxFiles={6}
        maxSize={15000000}
        name="attachments"
      />

      {error && <p className=" mb-4 text-p-sm text-text-semantic-error">{error}</p>}
      <div className="flex flex-col-reverse justify-between md:flex-row">
        <Button
          className="w-full bg-action-secondary md:flex md:w-auto"
          onClick={toggle}
          size={isTablet ? 'medium' : 'small'}
          variant="secondary"
        >
          Close
        </Button>
        <Button
          className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
          disabled={isCapturing || isMutationLoading}
          isLoading={isCapturing || isMutationLoading}
          size={isTablet ? 'medium' : 'small'}
          type="submit"
        >
          Submit
        </Button>
      </div>
    </Form>
  )
}
